import React, { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import ModalForm from 'components/modal/ModalForm';
import TriggerForm from 'components/forms/TriggerForm';

function TriggerModal(props) {
  const { title, modalTitle, hideButton, onSave, onClose, show, variant, ...rest } = props;
  const [showModal, setShowModal] = useState(!!show);
  const handleClose = () => {
    if (onClose) onClose();
    setShowModal(false);
  };
  const handleSave = (data) => {
    if (onSave) onSave(data);
    setShowModal(false);
  };
  const handleShow = (e) => {
    setShowModal(true);
  };

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  return (
    <ModalForm
      variant={variant}
      show={showModal}
      handleClose={handleClose}
      handleShow={handleShow}
      title={modalTitle || t`New trigger`}
      buttonTitle={title || t`Add trigger`}
      hideButton={hideButton}>
      <TriggerForm {...rest} onSave={handleSave} onCancel={handleClose}></TriggerForm>
    </ModalForm>
  );
}
TriggerModal.defaultProps = {
  trigger: { name: '' }
};

export default TriggerModal;
